import { supabase } from '../../lib/supabaseClient.js';
import { useState, useEffect } from 'react';
import './ClubActivitySection.css';

// 동아리 주요 활동을 표시하는 컴포넌트
export default function ClubActivitySection({ clubId }) {
    // 동아리 정보 저장
    const [club, setClub] = useState(null);

    // 로딩 상태 저장
    const [loading, setLoading] = useState(true);

    // 컴포넌트가 실행될 때 동아리 정보 조회
    useEffect(() => {
        getClub();
    }, []);

    // 동아리 주요 활동 정보 조회
    async function getClub() {
        const { data, error } = await supabase
            .from('clubs')
            .select('activities')
            .eq('id', clubId)
            .maybeSingle();

        if (error) {
            console.log(error);
            setLoading(false);
            return;
        }

        setClub(data);
        setLoading(false);
    }

    // 데이터 로딩 중 화면
    if (loading) {
        return <div>로딩중...</div>;
    }

    // 삭제된 동아리인 경우
    if (!club) {
        return <div className="ActivitySection">삭제된 동아리입니다.</div>;
    }

    return (
        <div className="ActivitySection">
            {/* 주요 활동 제목 */}
            <h1 className="ActivitySection-title">주요 활동</h1>

            {/* 주요 활동 목록 */}
            <div className="activity-list">
                {club.activities?.split('/').map((item, index) => (
                    <span key={index} className="ActivitySection-activity">
                        {item}
                    </span>
                ))}
            </div>
        </div>
    );
}